import * as Actions from 'app/store/actions';

const initialState = { data: null };

const adminEstimatedFluidSalesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ADMIN_ESTIMATED_FLUID_SALES_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default adminEstimatedFluidSalesReducer;
